export default "__VITE_ASSET__BlRLb21F__"